import React, { useEffect, useState } from 'react';
import Slider from "rc-slider";
import YouTube from 'react-youtube'
import styles from '../../css/styling.module.css';
import styles3 from '../../css/newStyling.module.css'
import { getActivityReplyImages } from '../../../actions/activities_reply_actions';
import ReactPlayer from 'react-player'
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { sendActivityReplyAnswers, sendSharableSurveyReplyAnswers } from '../../../actions/activities_reply_actions';

const Question_With_Spectrum = (props) => {
    const[selectColor, setSelectColor] = useState(null)
    // On option change
    const onOptionChange = (value) => {
setSelectColor(value)


// AUTO SAVE
        // let selectedAnswer = value;
        // let allContent = props.allContent
        // let questionId = props.allContent.pages[props.pageIndex].questions[props.questionIndex]._id

        // const replyObj = {
        //     answer: selectedAnswer,
        //     formContent: allContent,
        //     questionIndex: props.questionIndex,
        //     questionId: questionId,
        //     questionType: props.allContent.pages[props.pageIndex].questions[props.questionIndex].questionType,
        //     activityId: props.allContent.activityId,
        //     activityType: props.allContent.questionnaireType,
        //     pageNo: props.pageIndex,
        //     pageName: props.allContent.pages[props.pageIndex].pageName
        // }


        props.allContent.pages[props.pageIndex].questions[props.questionIndex].selected = value;
        props.setContent({ ...props.allContent });


        // if (userId) {
        //     dispatch(sendSharableSurveyReplyAnswers(params.ActivityId, replyObj, userId))
        //         .then((response => {
                   
        //         }))
        // }
        // else {
        //     dispatch(sendActivityReplyAnswers(params.surveyid, replyObj))
        //         .then((response => {
                  
        //         }))
        // }

    }

    const handleMarks = () => {

        let result = props.options.reduce((arr, val, index) => ({
            ...arr,
            [parseInt(((index + 1) / props.options.length) * 100)]: val

        }), {})

        return result;

    }

    const opts = {
        width: '640',
        height: '360',
        playerVars: {
            autoplay: 0
        },
    };

    const params = useParams();
    const pageIndex = props.pageIndex
    const questionIndex = props.questionIndex
    const userId = params.UserId
    const dispatch = useDispatch();

    const [localVideoUrls, setLocalVideoUrls] = useState({});
    const [loadingVideoLocal, setLoadingVideoLocal] = useState({});
    const [localImageUrls, setLocalImageUrls] = useState({});

    const loadVideoFile = (filePath) => {
        if (!filePath || localVideoUrls[filePath] || loadingVideoLocal[filePath]) return;

        setLoadingVideoLocal(prev => ({ ...prev, [filePath]: true }));

        dispatch(getActivityReplyImages([filePath]))
            .then((fileRes) => {
                const resolvedContent = fileRes.payload.content;
                const url = resolvedContent[0]?.fileData?.url || filePath;
                setLocalVideoUrls(prev => ({ ...prev, [filePath]: url }));
            })
            .catch(err => console.error('Failed to resolve video file:', err))
            .finally(() => {
                setLoadingVideoLocal(prev => {
                    const updated = { ...prev };
                    delete updated[filePath];
                    return updated;
                });
            });
    };

    const isVideoResolved = (file) => !!localVideoUrls[file];

    const getFileUrl = (file) => {
        if (typeof file === 'string') {
            if (localVideoUrls[file]) return localVideoUrls[file];
            if (localImageUrls[file]) return localImageUrls[file];
            return file;
        }
        return URL.createObjectURL(file);
    };

    const getFileExtension = (file) => {
        if (typeof file === 'string') {
            return file.split('?')[0].split('.').pop().toLowerCase();
        }
        return file.name.split('.').pop().toLowerCase();
    };

    useEffect(() => {
        if (Array.isArray(props.questionFile) && props.questionFile.length > 0) {
            const pathsToResolve = props.questionFile.filter(f => {
                if (typeof f !== 'string' || f === '') return false;
                const ext = f.split('?')[0].split('.').pop().toLowerCase();
                return ext !== 'mp4' && !localImageUrls[f];
            });

            if (pathsToResolve.length > 0) {
                dispatch(getActivityReplyImages(pathsToResolve))
                    .then((fileRes) => {
                        const resolvedContent = fileRes.payload.content;
                        const urlMap = {};
                        pathsToResolve.forEach((path, idx) => {
                            urlMap[path] = resolvedContent[idx]?.fileData?.url || path;
                        });
                        setLocalImageUrls(prev => ({ ...prev, ...urlMap }));
                    })
                    .catch(err => console.error('Failed to resolve image files:', err));
            }
        }
    }, [props.questionFile]);
    const makeLinksOpenInNewTab = (htmlContent) => {
        // Create a DOM element to parse the HTML content
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlContent;

        // Find all anchor tags within the parsed HTML content
        const anchorTags = tempElement.getElementsByTagName('a');

        // Iterate through the anchor tags and set the target attribute to '_blank'
        for (const anchorTag of anchorTags) {
            anchorTag.setAttribute('target', '_blank');
            // You can also set 'rel' attribute to 'noopener noreferrer' for security best practices
            anchorTag.setAttribute('rel', 'noopener noreferrer');
        }

        // Return the modified HTML content
        return tempElement.innerHTML;
    }

    const changeBackgroundColor = (index, length) => {

        let backgroundColor = ''
        if (length == 3) {

            switch (index) {

                case 0: return backgroundColor = '#ff4122'; //red
                case 1: return backgroundColor = '#ffa53f'; // orange
                case 2: return backgroundColor = '#4ded30' // green
            }
        }

        if (length == 4) {

            switch (index) {

                case 0: return backgroundColor = '#ff4122'; //red
                case 1: return backgroundColor = '#ffa53f'; //orange
                case 2: return backgroundColor = '#ffea61'; // yellow
                case 3: return backgroundColor = '#4ded30'; //green
            }
        }

        if (length == 5) {

            switch (index) {

                case 0: return backgroundColor = '#ff4122'; //red
                case 1: return backgroundColor = '#ffa53f'; //orange
                case 2: return backgroundColor = '#ffea61'; //yellow
                case 3: return backgroundColor = '#a7e074'; //parrot
                case 4: return backgroundColor = '#4ded30'; //green
            }
        }

        if (length == 6) {

            switch (index) {

                case 0: return backgroundColor = '#ff4122'; //red
                case 1: return backgroundColor = '#f4675a'; //vermilon
                case 1: return backgroundColor = '#ffa53f'; //orange
                case 2: return backgroundColor = '#ffea61'; //yellow
                case 3: return backgroundColor = '#a7e074'; //parrot
                case 4: return backgroundColor = '#4ded30'; //green
            }
        }



    }

    return (
        <div className="my-3">
            <div className={styles.card_border} style={props.required && !props.isAnswered ? { borderColor: '#d92550' } : {}}>
                <div className={styles.card_border_body + " pt-4 pb-1"}>
                    <p style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        {/* Required check */}
                        {props.required &&
                            <span className="text-danger mr-1">*</span>
                        }

                        {/* Question text */}
                        {props.questionText &&
                            <span style={{ color: '#000', fontSize: '27px', fontWeight: '500' }} className='mb-0' dangerouslySetInnerHTML={{ __html: makeLinksOpenInNewTab(props.questionText) }} />
                        }

                        {/* Question video */}
                        {props.questionVideo && (
                            <div>

                                <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>

                            </div>
                        )}

                    </p>

                    {/* Question Video */}
                    {
                        props.questionFile && props.questionFile.length > 0 && (
                            <div className="mx-3 mt-2 mb-4">
                                <div className="pt-3 d-flex flex-wrap" style={{ gap: '16px' }}>
                                    {props.questionFile.map((file, index) => {
                                        const ext = getFileExtension(file);
                                        const isVideoFile = ext === 'mp4';
                                        const fileUrl = getFileUrl(file);

                                        return (
                                            <div key={index} className="position-relative">
                                                {isVideoFile ? (
                                                    isVideoResolved(file) ? (
                                                        <div style={{ maxWidth: '300px', overflow: 'hidden' }}>
                                                            <ReactPlayer url={fileUrl} controls width="100%" />
                                                        </div>
                                                    ) : (
                                                        <div style={{
                                                            width: '200px', height: '140px',
                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            border: '2px dashed #ccc', borderRadius: '10px', backgroundColor: '#f8f9fa'
                                                        }}>
                                                            {loadingVideoLocal[file] ? (
                                                                <button type="button" className="btn btn-secondary d-flex align-items-center"
                                                                    style={{ color: 'white', fontSize: '12px', gap: '6px' }} disabled>
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    Downloading...
                                                                </button>
                                                            ) : (
                                                                <button type="button" className="btn btn-secondary"
                                                                    style={{ color: 'white', fontSize: '12px' }}
                                                                    onClick={() => loadVideoFile(file)}>
                                                                    Load Video
                                                                </button>
                                                            )}
                                                        </div>
                                                    )
                                                ) : (
                                                    <img src={fileUrl} className={`img-fluid border ${styles.banner_image} my-2`}
                                                        style={{ borderRadius: '10px', maxWidth: '300px' }} alt="img" />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )
                    }


                    {/* Options */}
                    <div className="table-responsive">
                        <div>
                            <div className="mx-4" style={{ height: 'auto', marginTop: 20 }}>

                                <div className='row d-flex my-2' style={{ justifyContent: 'center', gap:'10px' }}>
                                    {props.options.map((x, index) => {
                                        const dynamicSpectrum = changeBackgroundColor(index, props.options.length)
                                        return (

                                            <div style={{ minHeight: '6rem', width:'8rem', cursor: 'pointer',backgroundColor: selectColor === x ? '#E8F6FF':'', border:selectColor ===x? '2px solid #0069AB':'' }} className={`${styles3.card_border} d-flex align-items-center justify-content-center`} onClick={() => onOptionChange(x)}>
                                                <p className={`${styles3.spectrum_option} pt-2`}>{x}</p>

                                            </div>
                                        )
                                    })

                                    }

                                   

                                </div>
                                {/* <Slider
                                    dots
                                    included={false}
                                    min={parseInt((1 / props.options.length) * 100) - 10}
                                    max={110}
                                    marks={handleMarks()}
                                    value={(parseInt(((props.options.indexOf(props.selected) + 1) / props.options.length) * 100))}
                                    step={null}
                                    onChange={e => onOptionChange(handleMarks()[e])}
                                /> */}

                            </div>

                        </div>
                    </div>

                    {/* Required Answer error */}
                    {props.required && !props.isAnswered && (
                        <div id={`error-msg-${props.id}`}>
                            <div className="my-2">
                                <div className="alert alert-danger mb-0">
                                    Please answer this question.
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )

}

export default Question_With_Spectrum;
